import {
	Component,
	EventEmitter,
	forwardRef,
	Input,
	Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Product } from '@models/models';

@Component({
	selector: 'package-info-panel',
	template: require('./package-info-panel.component.html'),
	styles: [require('./package-info-panel.component.scss')],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PackageInfoPanelComponent),
			multi: true
		}
	]
})
export class PackageInfoPanelComponent implements ControlValueAccessor {
	@Input() product: Product;
	@Input() tax: number;
	@Input() quoteStatus: string;
	@Input() fromQuoteView?: boolean;
	@Input() currencySymbol: string;
	@Input() taxName: string;
	@Output()
	showPackageDetails: EventEmitter<Product> = new EventEmitter<Product>();
	selectedPackageId: number;
	private propagateChange = Function.prototype;

	constructor() {}

	showDetails(): void {
		this.showPackageDetails.emit(this.product);
	}

	writeValue(id: number): void {
		this.selectedPackageId = id;
	}

	registerOnChange(fn: Function): void {
		this.propagateChange = fn;
	}

	onChange(): void {
		// this.selectedPackageId = this.product.id;
		this.propagateChange(this.product);
	}

	registerOnTouched() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quotes/package-info-panel/package-info-panel.component.ts